import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$marketplace = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      add_config_marketplace: false,
      marketplace: [],
      lista_forma_pagamento: [],
      lista_forma_pagamento_loja: [],
      loading_marketplace: false,
      loading_button: false,
      loading_select: false,
      modalConfirm: false,
      loading: false,
      cadastro: {
        tipoFormaPagamento: [{ key: "DEFAULT", value: "Padrão" }],
        loading: false,
        cep: "",
        logradouro: "",
        bairro: "",
        estado: "",
        cidade: "",
        pais: "",
        email: "",
        nome_loja: "",
        tipo_forma_pag: "DEFAULT",
        forma_pag: [],
        idloja_neo: "",
        cor_primaria: "#1976D2",
        cor_secundaria: "#1976D2",
        marketing_imply_ativo: false,
        logotipo: { imagem: null, have: false },
        imagem: "",
        imagem_upload: { imagem: null },
        loading_imagem: false,
        logotipo_pos: { imagem: null, have: false },
        imagem_pos: "",
        imagem_upload_pos: { imagem_pos: null },
        loading_imagem_pos: false,
        banners_array: [],
        texto_banner: "",
        texto_banner_en: "",
        texto_banner_es: "",
        banner_link: "",
        tem_traducao: false,
        configsPlusAdd: "new",
        perguntas_frequentes: [],
        redes_sociais: [],
        contato: [],
        contato_sac: "",
        contato_email: "",
        exp_pedido: 0,
        configsPlusAddEdit: "new",
        politica_privacidade: [],
        politicas: [],
        email_envio_oper: "",
        url_front_qrcode: "",
        taxa_processamento: "",
        assertiva_cpf: false,
        error: {
          exp_pedido: [],
          politica_privacidade: [],
          politicas: [],
          email_envio_oper: [],
          url_front_qrcode: [],
          imagem: [],
          imagem_logo: [],
          logotipo_pos: [],
          logotipo_ingresso: [],
          logotipo: [],
        },
      },
      imagem: [],
      imagem_logo: [],
      logotipo_pos: [],
      logotipo: [],

      tipo_imagem: [
        { key: "Banner Rodapé", value: "banner_rodape", show: true },
      ],
      visualizarImagem: "",
      question: {
        ordem: "",
        pergunta_pt_BR: "",
        pergunta_en_US: "",
        pergunta_es_ES: "",
        resposta_pt_BR: "",
        resposta_en_US: "",
        resposta_es_ES: "",
        tem_traducao: false,
      },
      questionIdx: "",
      social_media: {
        ordem: "",
        descricao: "",
        valor: "",
      },
      social_mediaIdx: "",
      contato: {
        ordem: "",
        descricao: "",
        texto: "",
      },
      contatoIdx: "",
      politica_privacidade: {
        descricao_pt_BR: "",
        descricao_en_US: "",
        descricao_es_ES: "",
        texto_pt_BR: "",
        texto_en_US: "",
        texto_es_ES: "",
        tem_traducao: false,
      },
      politicaIdx: "",
      indexValue: "",
      indexImageOrDoc: "",
      valueImageOrDoc: "",
      funcao: "",
      text: "",
    };
  },
  methods: {
    /**
     * @description Método para listar as configurações do marketplace
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getConfigMarketplace() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_CONFIG_MARKET)
        .then(response => {
          //bloco dados cadastrais
          this.cadastro.nome_loja =
            response.nome_loja === null ? "" : response.nome_loja;
          this.cadastro.contato_email =
            response.contato_email === null ? "" : response.contato_email;
          this.cadastro.contato_sac =
            response.contato_sac === null ? "" : response.contato_sac;
          this.cadastro.pais =
            response.end_pais === null ? "" : response.end_pais;
          this.cadastro.cep = response.end_cep === null ? "" : response.end_cep;
          this.cadastro.estado =
            response.end_estado === null ? "" : response.end_estado;
          this.cadastro.cidade =
            response.end_cidade === null ? "" : response.end_cidade;
          this.cadastro.bairro =
            response.end_bairro === null ? "" : response.end_bairro;
          this.cadastro.logradouro =
            response.end_logradouro === null ? "" : response.end_logradouro;

          //bloco tema
          this.cadastro.marketing_imply_ativo =
            response.marketing_imply_ativo === null
              ? 0
              : response.marketing_imply_ativo;
          this.cadastro.cor_primaria =
            response.cor_primaria === null ? "#1976D2" : response.cor_primaria;
          this.cadastro.cor_secundaria =
            response.cor_secundaria === null
              ? "#1976D2"
              : response.cor_secundaria;
          if (response.logotipo) {
            this.cadastro.logotipo.imagem = response.logotipo;
            this.cadastro.logotipo.have = true;
            this.cadastro.logotipo.imagem =
              response.logotipo == null ? "" : response.logotipo;
          }
          if (response.logotipo_pos) {
            this.cadastro.logotipo_pos.imagem = response.logotipo_pos;
            this.cadastro.logotipo_pos.have = true;
            this.cadastro.logotipo_pos.imagem =
              response.logotipo_pos == null ? "" : response.logotipo_pos;
          }

          // this.cadastro.logotipo_pos.imagem =
          //   response.logotipo_pos == null ? "" : response.logotipo_pos;
          let bannerImg = JSON.parse(response.banners);
          if (bannerImg) {
            const arrayOfObj = Object.entries(bannerImg).map(e => ({
              [e[0]]: e[1],
            }));

            this.cadastro.banners_array = arrayOfObj;
          }
          this.cadastro.tem_traducao =
            response.banner_texto_traducao === null
              ? false
              : response.banner_texto_traducao;
          this.cadastro.texto_banner =
            response.banner_texto === null ? "" : response.banner_texto;
          this.cadastro.texto_banner_en =
            response.banner_texto_en === null ? "" : response.banner_texto_en;
          this.cadastro.texto_banner_es =
            response.banner_texto_es === null ? "" : response.banner_texto_es;

          //dados  banc
          this.cadastro.forma_pag = response.nidforma_pag
            ? response.nidforma_pag.split(";")
            : [];
          this.cadastro.idloja_neo =
            response.idloja_neo == null ? "" : response.idloja_neo;

          //taxas
          this.cadastro.taxa_processamento =
            response.taxa_processamento === null
              ? ""
              : response.taxa_processamento;
          this.cadastro.exp_pedido =
            response.exp_pedido === null ? 0 : response.exp_pedido;
          this.cadastro.banner_link =
            response.banner_link === null ? "" : response.banner_link;

          //config adc
          this.cadastro.perguntas_frequentes =
            response.faq === null ? "" : JSON.parse(response.faq);
          this.cadastro.redes_sociais =
            response.redes_sociais === null
              ? ""
              : JSON.parse(response.redes_sociais);
          this.cadastro.contato =
            response.contato === null ? "" : JSON.parse(response.contato);
          this.cadastro.assertiva_cpf = response.validar_cpf;
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para cadastrar ou alterar as configurações do marketplace
     * @param {Object} dados - Dados da configuração marketplace
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async cadastrarConfigMarketplace() {
      this.loading_button = true;
      let banners = {};

      this.cadastro.banners_array.forEach(item => {
        banners[Object.keys(item)] = Object.values(item)[0];
      });
      let dados = {
        //dados cadastrais
        nome_loja: this.cadastro.nome_loja,
        end_pais: this.cadastro.pais,
        end_cep: this.cadastro.cep,
        end_estado: this.cadastro.estado,
        end_cidade: this.cadastro.cidade,
        end_bairro: this.cadastro.bairro,
        end_logradouro: this.cadastro.logradouro,

        //TEMA
        marketing_imply_ativo: this.cadastro.marketing_imply_ativo,
        banner_link: this.cadastro.banner_link,
        cor_primaria: this.cadastro.cor_primaria,
        cor_secundaria: this.cadastro.cor_secundaria,
        logotipo: this.cadastro.logotipo.imagem,
        logotipo_pos:
          this.cadastro.logotipo_pos.imagem == []
            ? ""
            : this.cadastro.logotipo_pos.imagem,
        banners: JSON.stringify(banners),
        banner_texto_traducao: this.cadastro.tem_traducao,
        banner_texto: this.cadastro.tem_traducao
          ? `<pt_BR>${this.cadastro.texto_banner}</pt_BR><en_US>${this.cadastro.texto_banner_en}</en_US><es_ES>${this.cadastro.texto_banner_es}</es_ES>`
          : this.cadastro.texto_banner,

        //DADOS BANC
        nidforma_pag:
          this.cadastro.forma_pag.length > 0
            ? this.cadastro.forma_pag.join(";")
            : "",
        idloja_neo: this.cadastro.idloja_neo,

        //CONFIG ADC
        faq: JSON.stringify(this.cadastro.perguntas_frequentes),
        redes_sociais: JSON.stringify(this.cadastro.redes_sociais),
        contato: JSON.stringify(this.cadastro.contato),
        politicas: JSON.stringify(this.cadastro.politicas),
        contato_sac: this.cadastro.contato_sac,
        contato_email: this.cadastro.contato_email,

        //TAXAS
        exp_pedido: parseInt(this.cadastro.exp_pedido),
        taxa_processamento: this.cadastro.taxa_processamento,

        //VENDAS
        validar_cpf: this.cadastro.assertiva_cpf,
      };
      await this.$axios
        .post(this.ENDPOINTS.ALTERAR_CONFIG_MARKET, dados)
        .then(() => {
          this.add_config_marketplace = false;
          this.getConfigmarketplace();
        })
        .catch(() => {
          this.loading_button = false;
        });
    },

    /**
     * @description Função que valida o cadastro
     */
    async validarCadastro() {
      if (this.cadastro.exp_pedido === "") {
        this.$config.alert(
          "Preencha o tempo de expiração do pedido!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.exp_pedido =
          "Preencha o tempo de expiração do pedido!";
        return;
      } else if (this.cadastro.exp_pedido <= 0) {
        this.$config.alert(
          "O tempo de expiração do pedido deve ser maior que 0!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.exp_pedido =
          "O tempo de expiração do pedido deve ser maior que 0!";
        return;
      }

      /**
       * @description Bloco que chama a função para o cadastro/alteração.
       */
      this.cadastrarConfigMarketplace();
    },

    /**
     * @description Função que confirma a remoção das configs adicionais
     */
    funcaoRemover(funcao) {
      switch (funcao) {
        case "question":
          this.cadastro.perguntas_frequentes.splice(this.indexValue, 1);
          break;
        case "social":
          this.cadastro.redes_sociais.splice(this.indexValue, 1);
          break;
        case "contact":
          this.cadastro.contato.splice(this.indexValue, 1);
          break;
        case "policy":
          this.cadastro.politicas.splice(this.indexValue, 1);
          break;
        case "image":
          this.removeImage(this.indexImageOrDoc, this.valueImageOrDoc);
          break;
        case "document":
          this.removeDOC(this.indexImageOrDoc, this.valueImageOrDoc);
          break;
        case "privacidade":
          this.cadastro.politica_privacidade.splice(this.indexValue, 1);
          break;
        default:
          break;
      }
    },

    /**
     * @description Função que abre modal para adicionar politica de privacidade do marketplace
     */
    openModal(name, type, table, data, idx) {
      document.getElementsByClassName(name)[0].style.display = "flex";
      this.cadastro.configsPlusAddEdit = type;

      switch (table) {
        case "question":
          if (data) {
            this.question.ordem = data.ordem;

            let perguntaBR = [];
            let respostaBR = [];
            let perguntaEN = [];
            let respostaEN = [];
            let perguntaES = [];
            let respostaES = [];

            perguntaBR.push(data.pergunta.indexOf("<pt_BR>"));
            perguntaBR.push(data.pergunta.indexOf("</pt_BR>"));
            respostaBR.push(data.resposta.indexOf("<pt_BR>"));
            respostaBR.push(data.resposta.indexOf("</pt_BR>"));
            this.question.pergunta_pt_BR = data.pergunta.substring(
              perguntaBR[0] + 7,
              perguntaBR[1]
            );
            this.question.resposta_pt_BR = data.resposta.substring(
              respostaBR[0] + 7,
              respostaBR[1]
            );

            perguntaEN.push(data.pergunta.indexOf("<en_US>"));
            perguntaEN.push(data.pergunta.indexOf("</en_US>"));
            respostaEN.push(data.resposta.indexOf("<en_US>"));
            respostaEN.push(data.resposta.indexOf("</en_US>"));
            this.question.pergunta_en_US = data.pergunta.substring(
              perguntaEN[0] + 7,
              perguntaEN[1]
            );
            this.question.resposta_en_US = data.resposta.substring(
              respostaEN[0] + 7,
              respostaEN[1]
            );

            perguntaES.push(data.pergunta.indexOf("<es_ES>"));
            perguntaES.push(data.pergunta.indexOf("</es_ES>"));
            respostaES.push(data.resposta.indexOf("<es_ES>"));
            respostaES.push(data.resposta.indexOf("</es_ES>"));
            this.question.pergunta_es_ES = data.pergunta.substring(
              perguntaES[0] + 7,
              perguntaES[1]
            );
            this.question.resposta_es_ES = data.resposta.substring(
              respostaES[0] + 7,
              respostaES[1]
            );

            if (this.question.pergunta_en_US || this.question.pergunta_es_ES) {
              this.question.tem_traducao = true;
            }

            this.questionIdx = idx;
          }
          return;
        case "social":
          this.social_media.ordem = data.ordem;
          this.social_media.descricao = data.titulo;
          this.social_media.valor = data.valor;
          this.social_mediaIdx = idx;
          return;
        case "contact":
          this.contato.ordem = data.ordem;
          this.contato.descricao = data.titulo;
          this.contato.texto = data.valor;
          this.contatoIdx = idx;
          return;
        case "policy":
          if (data) {
            this.politica_privacidade.descricao_pt_BR = data.titulo.substring(
              data.titulo.indexOf("<pt_BR>") + 7,
              data.titulo.indexOf("</pt_BR>")
            );
            this.politica_privacidade.descricao_en_US = data.titulo.substring(
              data.titulo.indexOf("<en_US>") + 7,
              data.titulo.indexOf("</en_US>")
            );
            this.politica_privacidade.descricao_es_ES = data.titulo.substring(
              data.titulo.indexOf("<es_ES>") + 7,
              data.titulo.indexOf("</es_ES>")
            );
            this.politica_privacidade.texto_pt_BR = data.valor.substring(
              data.valor.indexOf("<pt_BR>") + 7,
              data.valor.indexOf("</pt_BR>")
            );
            this.politica_privacidade.texto_en_US = data.valor.substring(
              data.valor.indexOf("<en_US>") + 7,
              data.valor.indexOf("</en_US>")
            );
            this.politica_privacidade.texto_es_ES = data.valor.substring(
              data.valor.indexOf("<es_ES>") + 7,
              data.valor.indexOf("</es_ES>")
            );

            this.politica_privacidade.tem_traducao = data.tem_traducao;
            this.politicaIdx = idx;
          }
          return;
        default:
          "teste";
          return;
      }
    },

    /**
     * @description Função que remove a imagem da loja
     */
    removeImage(index, i) {
      this.cadastro.banners_array.splice(index, 1);
      let tipo = this.tipo_imagem.find(item => item.value === i);
      if (tipo) {
        tipo.show = true;
      }
    },

    /**
     * @description Função que abre modal para confirmar remoção das configurações do marketplace
     */
    remover(index, type, name, msg) {
      this.text = msg;
      this.funcao = type;
      this.indexValue = index;
      this.indexImageOrDoc = index;
      this.valueImageOrDoc = name;
      this.$config.modalConfirm = true;
    },

    limpaFormularioDeConfigMarketplace() {
      this.cadastro.exp_pedido = "";
      this.cadastro.banner_link = "";
      this.cadastro.politica_privacidade = "";
      this.cadastro.email_envio_oper = "";
      this.cadastro.url_front_qrcode = "";
      this.cadastro.taxa_processamento = "";
      this.cadastro.nome_loja = "";
      this.cadastro.pais = "";
      this.cadastro.cep = "";
      this.cadastro.estado = "";
      this.cadastro.cidade = "";
      this.cadastro.bairro = "";
      this.cadastro.logradouro = "";
    },
  },
});
